import { supabase } from '../lib/supabase';

/**
 * Global unified search service that searches across multiple tables
 * Returns categorized results from events, products, spots, and marketplace_items
 */

export const searchService = {
  /**
   * Performs a unified search across all searchable tables
   * @param {string} query - The search query string
   * @returns {Promise<Object>} - Categorized search results
   */
  async globalSearch(query) {
    if (!query || query?.trim()?.length < 2) {
      return {
        events: [],
        products: [],
        spots: [],
        marketplace: []
      };
    }

    const searchTerm = `%${query?.trim()}%`;

    try {
      // Search events (title field)
      const { data: events, error: eventsError } = await supabase?.from('events')?.select('id, title, event_date, location, price_own_board')?.ilike('title', searchTerm)?.eq('status', 'published')?.limit(5);

      if (eventsError) throw eventsError;

      // Search products (title field)
      const { data: products, error: productsError } = await supabase?.from('products')?.select('id, title, price, category, images')?.ilike('title', searchTerm)?.eq('is_active', true)?.limit(5);

      if (productsError) throw productsError;

      // Search spots (name field)
      const { data: spots, error: spotsError } = await supabase?.from('spots')?.select('id, name, location, difficulty_level, image_url')?.ilike('name', searchTerm)?.limit(5);

      if (spotsError) throw spotsError;

      // Search marketplace items (title field)
      const { data: marketplace, error: marketplaceError } = await supabase?.from('marketplace_items')?.select('id, title, price, condition, images')?.ilike('title', searchTerm)?.eq('is_sold', false)?.limit(5);

      if (marketplaceError) throw marketplaceError;

      return {
        events: events || [],
        products: products || [],
        spots: spots || [],
        marketplace: marketplace || []
      };
    } catch (error) {
      console.error('Global search error:', error);
      throw error;
    }
  },

  /**
   * Gets the total count of results across all categories
   * @param {Object} results - The search results object
   * @returns {number} - Total number of results
   */
  getTotalResultsCount(results) {
    return (
      (results?.events?.length || 0) +
      (results?.products?.length || 0) +
      (results?.spots?.length || 0) +
      (results?.marketplace?.length || 0)
    );
  }
};